<form id="loginForm" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="login-form">
  <div class="title">
    <h2>Mot de passe oublié</h2>
    <p>Veuillez saisir votre adresse e-mail pour recevoir un lien de réinitialisation.</p>
  </div>
  <div class="auth centered-flex">
    <label for="email" class="outside-window">Email</label>
    <input
      id="email"
      formControlName="email"
      type="email"
      class="auth-container"
      placeholder="Email"
      [ngClass]="{ 'is-invalid': isSubmitted && email.invalid }" />
  </div>
  <div class="error-msg">
    @if (isSubmitted && email.errors?.['required']) {
      <span>Email requis</span>
    }
    @if (isSubmitted && email.errors?.['pattern']) {
      <span>Format d'email invalide</span>
    }
  </div>

  <hr />

  <div class="auth">
    <button type="submit" class="button-component" id="login">Envoyer le lien</button>
  </div>
</form>
